import { ChangeDetectionStrategy, Component, Input, computed, inject } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { toSignal } from '@angular/core/rxjs-interop';

import { CrmInboxService } from '~/core/services/crm-inbox.service';
import { TopbarIconButtonComponent } from '~/components/topbar-icon-button/topbar-icon-button.component';

@Component({
  selector: 'app-crm-inbox-button',
  imports: [TopbarIconButtonComponent, MatBadgeModule],
  templateUrl: './crm-inbox-button.component.html',
  styleUrls: ['./crm-inbox-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CrmInboxButtonComponent {
  private readonly crmInboxService = inject(CrmInboxService);

  @Input() customImage?: string;
  @Input() customTitle?: string;

  private readonly _isActive = toSignal(this.crmInboxService.isActive(), { initialValue: false });

  readonly isVisible = computed(() => this._isActive() && this.crmInboxService.isAnyInboxEnabled());
  readonly count = toSignal(this.crmInboxService.getUnreadCount(), { initialValue: 0 });
  readonly badgeClass = computed(() => (this.count() > 0 ? 'badge-active' : ''));

  openInbox(): void {
    if (this.isVisible()) {
      this.crmInboxService.openInbox();
    }
  }
}
